export default {
  cancellationId: (state, id) => {
    state.cancellationId = id;
  },
  setCancellation(state, cancellation) {
    state.cancellation = cancellation;
  },
  setPaymentMethods(state, paymentMethods) {
    let maxPrio = 0;
    paymentMethods.forEach(paymentMethod => {
      if ('id' in paymentMethod) {
        state.payments[paymentMethod.id] = paymentMethod;
        if (paymentMethod.priority > maxPrio) {
          maxPrio = paymentMethod.priority;
          state.formFields.product = paymentMethod.id;
        }
      }
    });
    state.paymentMethods = paymentMethods;
  },
  setOptionalProduct(state, optionalProduct) {
    state.optionalProduct = optionalProduct;
  },
  addSubCancellation(state, payload) {
    state.subCancellations[payload.id] = payload.subCancellation;
  },
  addCancellationOption(state, payload) {
    if (payload.id === undefined || payload.text === undefined) {
      throw new Error(`Payload broke: ${payload.id} => ${payload.text} - full object: ${JSON.stringify(payload)}`);
    }
    state.cancellationOptions.push({
      id: payload.id,
      text: payload.text,
    });
  },
  setActiveCancellation(state, payload) {
    state.activeCancellation = payload;
    state.formFields.cancellation = payload.id;
    state.cancellationId = payload.id;
  },
  setupComplete(state, payload) {
    state.setupComplete = payload;
  },
  setAddress(state, payload) {
    if (undefined === payload || null === payload || false === payload) {
      return;
    }
    state.formFields.customerCity = payload.city;
    state.formFieldValidityStates.customerCity = true;
    if ('nl_sixpp' in payload) {
      state.country.netherlands = true;
      state.country.belgium = false;
      state.formFields.customerCountry = 'NL';
      state.formFields.customerStreet = payload.street;
    } else if ('fourpp' in payload) {
      state.country.belgium = true;
      state.country.netherlands = false;
      state.formFields.customerCountry = 'BE';
    } else {
      state.country.belgium = false;
      state.country.netherlands = false;
      state.formFields.customerCountry = undefined;
    }
  },
  updatePostcodeCountry(state, country) {
    state.country.netherlands = country.netherlands;
    state.country.belgium = country.belgium;
  },
  clearPaymentMethods(state) {
    state.paymentMethods = [];
    state.payments = {};
  },
  signatureData(state, payload) {
    state.signatureData = payload;
  },
  addPaymentType(state, payload) {
    state.paymentType[payload.name] = payload.value;
    state.paymentTypeValidity[payload.name] = Boolean(payload.optional);
  },
  addFormField(state, payload) {
    state.formFields[payload.name] = payload.value;
    if (false === payload.optional) {
      state.formFieldValidityStates[payload.name] = false; // Initialize form field validity to false.
    }
  },
  updateFormField(state, payload) {
    if (Object.keys(state.formFields).includes(payload.name)) {
      state.formFields[payload.name] = payload.value;
    }
  },
  updateIbanFormField(state, payload) {
    state.ibanFormField = payload.value;
  },
  updateReasonToCancelFormField(state, payload) {
    state.reasonToCancelFormField = payload.value;
  },
  updateAdditionalFormField(state, payload) {
    state.additionalFormFieldValues[payload.name] = payload.value;
  },
  updateFormFieldValidity(state, payload) {
    state.formFieldValidityStates[payload.name] = Boolean(payload.valid);
  },
  updatePaymentTypeField(state, payload) {
    state.paymentType[payload.name] = payload.value;
  },
  updatePaymentTypeValidity(state, payload) {
    state.paymentTypeValidity[payload.name] = Boolean(payload.valid);
  },
  addAdditionalFormFields(state, payload) {
    payload.forEach((formField) => {
      state.additionalFormFields[formField.slug] = formField;
      state.formFieldValidityStates[formField.slug] = 'opzegdatum' === formField.slug ? true : !formField.required;
    });
  },
  addAdditionalFormFieldValues(state, payload) {
    payload.forEach((formField) => {
      state.additionalFormFieldValues[formField.slug] = null;
    });
  },
  clearAdditionalFormFields(state) {
    state.additionalFormFields = {};
  },
  clearAdditionalFormFieldValues(state) {
    state.additionalFormFieldValues = {};
  },
  showErrors(state, show) {
    state.showErrors = show;
  },
  showPaymentTypeErrors(state, show) {
    state.showPaymentTypeErrors = show;
  },
  setInputRef(state, payload) {
    state.inputRefs[payload.name] = payload.ref;
  },
  freeInputRef(state, name) {
    delete state.inputRefs[name];
  },
  cacheSave: (state, payload) => {
    const streetKey = payload.houseNumber + payload.houseNumberExtension;
    const postcodeKey = payload.postcode;
    if (undefined === state.cache[postcodeKey]) {
      state.cache[postcodeKey] = {};
    }
    if (undefined === state.cache[postcodeKey][streetKey]) {
      state.cache[postcodeKey][streetKey] = payload.value;
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Unneeded cache save was called with payload: ${JSON.stringify(payload)}`);
    }
  },
  setAddressValidity: (state, validity) => {
    state.addressIsValid = validity;
  },
  requireDrawnSignature: (state, required) => {
    state.drawnSignatureRequired = required;
  },
  signatureMode: (state, mode) => {
    state.signatureMode = mode;
  },
  updateSignatureFromDrawing: (state) => {
    state.formFields.customerSignature = state.adivareSignaturePad.canvasToDataURL();
    state.signatureData = state.adivareSignaturePad.toData();
    state.formFieldValidityStates.customerSignature = true;
  },
  clearSignature: (state) => {
    state.formFields.customerSignature = undefined;
    state.signatureData = undefined;
    state.formFieldValidityStates.customerSignature = false;
  },
  isLoading: (state, value) => {
    state.isLoading = value;
  },
  generic: (state, value) => {
    state.generic = value;
  },
  cancellationDate: (state, value) => {
    state.cancellationDate = value;
  },
  reasonToCancelRequired: (state, value) => {
    state.reasonToCancelRequired = value;
  },
  totalPrice: (state, value) => {
    state.totalPrice = value;
  },
};
